<script>
import resetPasswordModal from "@/components/resetPasswordModal";
import orBreak from "@/components/common/orBreak";

export default {
  name: "login-form",
  components: {
    resetPasswordModal,
    orBreak,
  },
  data: function() {
    return {
      email: "",
      password: "",
      isResetModalShown: false,
      emailRules: [(v) => !!v || "Email is required", (v) => this.validateEmail(v) || "Invalid Email Address"],
      showPassword: false,
      autofilledPassword: false,
      autoFilledEmail: false,
      rememberMe: true,
      showResetPassword: false,
      isLoggingIn: false,
    };
  },
  methods: {
    async attemptLogin() {
      if (this.isValid()) {
        this.isLoggingIn = true;
        await this.$store.dispatch("attemptLogin", { email: this.email, password: this.password });
      }
    },

    clearError: function() {},
    onKeyup: function(event) {
      if (event.key == "Enter") {
        this.attemptLogin();
      } else {
        this.clearError();
      }
    },
    onResetPasswordClick: function() {
      this.$store.commit("toggleResetPasswordModal", true);
    },
    validateEmail(email) {
      return validateEmail(email);
    },
    isValid() {
      return this.$refs.form.validate();
    },
    closeModal() {
      this.showResetPassword = false;
    },
  },
  mounted() {},
  computed: {
    isLoginError: function() {
      return this.$store.state.isLoginError;
    },
    canLogin: function() {
      return this.email && this.password;
    },
  },
  watch: {
    password() {
      this.autofilledPassword = true;
    },
    email() {
      this.autoFilledEmail = true;
    },
  },
};
</script>
<template>
  <div>
    <div style="position:absolute;top:0px;right:0px;bottom:0px;left:0px;">
      <v-img height="100%" width="100%" src="../assets/images/login-splash.jpg" lazy-src="../assets/images/login-splash-lr.jpg"></v-img>
    </div>
    <v-row>
      <v-col cols="12" sm="8" offset-sm="2" md="6" lg="4" offset="0" offset-md="3" offset-lg="4">
        <v-card class="pa-5">
          <v-form ref="form">
            <v-row>
              <v-img class=" ml-auto mr-auto" max-width="50%" :cover="true" contain src="../assets/images/sea-projects.png"></v-img>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  color="primary"
                  hide-details="auto"
                  dense
                  class="login-textfield"
                  :placeholder="!autoFilledEmail ? ' ' : ''"
                  v-model="email"
                  label="Email Address"
                  :rules="emailRules"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  hide-details="auto"
                  dense
                  class="login-textfield"
                  background-color="transparent"
                  :placeholder="!autofilledPassword ? ' ' : ''"
                  v-model="password"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword ? 'text' : 'password'"
                  label="Password"
                  outlined
                  @click:append="showPassword = !showPassword"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
          <v-row>
            <v-col cols="12"> <v-btn color="primary" style="width:100%" v-on:click="attemptLogin" :loading="isLoggingIn">Login</v-btn><br /> </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<style scoped>
.v-card {
  border-radius: 1px;
  background-color: rgba(255, 255, 255, 0.8);
}

.input-group-text {
  background: none;
  border-top: 0px;
  border-right: 0px;
  border-left: 0px;
  border-radius: 0px;
}
input {
  border-top: 0px !important;
  border-right: 0px !important;
  border-left: 0px !important;
  border-radius: 0px !important;
  background-color: transparent !important;
  color: #004996;
}
::placeholder {
  color: #004996;
}
.v-input--selection-controls {
  margin-top: 0px;
}
</style>
